import Toast from "../components/Toast";
import servicesUtils from "./servicesUtils";
import { getFCMToken, getPlatform, isAndroidWebView, isIOSWebView } from ".";
import Store from "./Store";
import constants from "./constants";
import { t } from "i18next";

export const registerSubscription = (token?: string | null) => {
  const params = {
    token,
    platform: getPlatform(),
  };
  return servicesUtils
    .postService("/subscription/", params)
    .then(() => {
      return true;
    })
    .catch(() => {
      Toast.error(t("unable_to_subscribe"));
      return false;
    });
};

export const unRegisterSubscription = (token?: string | null) => {
  const params = { token };
  return servicesUtils.postService("/subscription/delete/", params);
};

export const subscribeUserNotification = async (RNFcmToken?: string) => {
  try {
    let token: string | null = RNFcmToken || null;
    if (!token && !isAndroidWebView() && !isIOSWebView()) {
      const status = await window?.Notification?.requestPermission();
      if (status && status === "granted") {
        token = await getFCMToken();
      } else if (status && status === "denied") {
        Toast.error(t("allow_browser_permission"));
      }
    }
    if (token) {
      const old_fcmToken = window?.localStorage.getItem(constants.PERSISTED.fcmToken);
      if (old_fcmToken && token != old_fcmToken) {
        unRegisterSubscription(old_fcmToken);
        window?.localStorage.removeItem(constants.PERSISTED.fcmToken);
      }
      const isSuccess = await registerSubscription(token);
      if (isSuccess) {
        window?.localStorage.setItem(constants.PERSISTED.fcmToken, token);
      }
      if (isSuccess && !RNFcmToken) {
        Store.update((s) => {
          s.fcmToken = token;
        });
      }
      return isSuccess;
    }
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
};
